import React from "react";
import css from "./section.module.css";
import resources from "./../../../../resources/index";
import TeamMember from "./TeamMember";

const Section4 = () => {
  const teamData = [
    {
      image: resources.images.team.team_1,
      name: "John Sullivan",
      title: "Front End Developer",
    },
    {
      image: resources.images.team.team_2,
      name: "John Sullivan",
      title: "Front End Developer",
    },
    {
      image: resources.images.team.team_3,
      name: "John Sullivan",
      title: "Front End Developer",
    },
    {
      image: resources.images.team.team_4,
      name: "John Sullivan",
      title: "Front End Developer",
    },
    {
      image: resources.images.team.team_5,
      name: "John Sullivan",
      title: "Front End Developer",
    },
    {
      image: resources.images.team.team_6,
      name: "John Sullivan",
      title: "Front End Developer",
    },
    {
      image: resources.images.team.team_7,
      name: "John Sullivan",
      title: "Front End Developer",
    },
    {
      image: resources.images.team.team_8,
      name: "John Sullivan",
      title: "Front End Developer",
    },
  ];
  return (
    <div className={css.section4}>
      <div className={css.div1}>
        <h4>Our Team</h4>
        <h2>The People Behind Quiety</h2>
        <p>
          Intrinsicly strategize cutting-edge before interoperable applications
          incubate extensive expertise through integrated intellectual capital.
        </p>
      </div>
      <div className={css.div2}>
      {
        teamData.map((data, index)=>{
          return(
            <TeamMember key={index} data = {data} />
          )
        })
      }
      </div>
    </div>
  );
};

export default Section4;
